/* 営業日カレンダー */
import React from 'react';
import RowTemplate from '../atoms/RowTemplate';
import moment from 'moment';
import Messages from '../molecules/Messages';
import Paragraph from '../atoms/Paragraph';
import { business_day_calendar as config } from '../Const';
import ja from 'date-fns/locale/ja';
import DatePicker from 'react-datepicker';
var BusinessDayCalendar = function (_a) {
    var id = _a.id, label = _a.label, need = _a.need, value = _a.value, message = _a.message, name = _a.name, placeholder = _a.placeholder, help_msg = _a.help_msg, disabled = _a.disabled, handleChange = _a.handleChange, handleBlur = _a.handleBlur;
    // 開始日から終了日までの年のコレクションを作成する
    var years = [];
    var dateFrom = moment(new Date()).add(config.min_date, 'd');
    var dateTo = moment(new Date()).add(config.max_year, 'y').subtract('1', 'd');
    for (var i = Number(dateFrom.format('YYYY')); i <= Number(dateTo.format('YYYY')); i++) {
        years.push(i);
    }
    // 月のコレクション
    var months = [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月',
    ];
    /**
     * 年月日の日本語文字列を生成する
     * @return string 日本語の年月日
     */
    var returnStringDateJp = function () {
        if (value !== null && typeof value !== 'undefined') {
            var year = value.getFullYear();
            var month = value.getMonth() + 1;
            var date = value.getDate();
            return year + "\u5E74" + month + "\u6708" + date + "\u65E5";
        }
        return '';
    };
    /**
     * 日付加算(日)
     * @param add 追加する日数
     * @return Date 日付オブジェクト
     */
    var addDays = function (add) {
        return moment(new Date()).add(add, 'd').toDate();
    };
    /**
     * 日付加算(年)
     * @param add 追加する年数
     * @return Date 日付オブジェクト
     */
    var addYears = function (add) {
        return moment(new Date()).add(add, 'y').add(-1, 'd').toDate();
    };
    /**
     * 非活性状態の時に出力するJSX.ELement
     * @returns JSX.Element
     */
    var disabledJsxElement = function () {
        return React.createElement(Paragraph, { label: returnStringDateJp() });
    };
    /**
     * 活性状態の時に出力するJSX.ELement
     * @returns JSX.Element
     */
    var enabledJsxElement = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(DatePicker, { id: id, className: "form-control", disabled: disabled, locale: ja, onChange: handleChange, selected: value !== null && value !== void 0 ? value : null, placeholderText: placeholder, name: name, dateFormat: "yyyy\u5E74MM\u6708dd\u65E5", showPopperArrow: false, onBlur: handleBlur, minDate: addDays(config.min_date), maxDate: addYears(config.max_year), renderCustomHeader: function (_a) {
                    var date = _a.date, changeYear = _a.changeYear, changeMonth = _a.changeMonth, decreaseMonth = _a.decreaseMonth, increaseMonth = _a.increaseMonth, prevMonthButtonDisabled = _a.prevMonthButtonDisabled, nextMonthButtonDisabled = _a.nextMonthButtonDisabled;
                    return (React.createElement("div", null,
                        React.createElement("button", { onClick: decreaseMonth, disabled: prevMonthButtonDisabled, className: "react-datepicker__navigation react-datepicker__navigation--previous" }, '<'),
                        React.createElement("select", { value: date.getFullYear(), onChange: function (_a) {
                                var value = _a.target.value;
                                return changeYear(Number(value));
                            } }, years.map(function (option) { return (React.createElement("option", { key: option, value: option }, option)); })),
                        React.createElement("span", null, "\u5E74"),
                        React.createElement("select", { value: months[date.getMonth()], onChange: function (_a) {
                                var value = _a.target.value;
                                return changeMonth(months.indexOf(value));
                            } }, months.map(function (option) { return (React.createElement("option", { key: option, value: option }, option)); })),
                        React.createElement("button", { onClick: increaseMonth, disabled: nextMonthButtonDisabled, className: "react-datepicker__navigation react-datepicker__navigation--next" }, '>')));
                } }),
            React.createElement(Messages, { help_msg: help_msg, valid_msg: message })));
    };
    return (React.createElement(RowTemplate, { label: label, need: need, disabled: disabled, content: disabled ? disabledJsxElement() : enabledJsxElement() }));
};
export default BusinessDayCalendar;
